module.exports = __webpack_public_path__ + "img/spore_lines_mobile.385e8347.png";